import type { CreateUserPayloadInput } from '@domain/schemas/payload.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { CreateUserResponse } from '@responses/users';
import axios from 'axios';

export const createUser = async (data: CreateUserPayloadInput): Promise<CreateUserResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'post',
    url: `users`,
    data,
  });

  const response = await axios(networkPayload);
  return response.data;
};
